import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Step 1: Representative Information
  fullName: "",
  email: "",
  phone: "",
  country: "",
  relationship: "",

  // Step 2: Influencer Details
  influencerFullName: "",
  influencerEmail: "",
  influencerPhone: "",
  influencerCountry: "",

  // Step 3: Why Impactoverse
  whyJoin: "",
  causes: [],

  // Step 4: Social Media Accounts
  organizationLinks: {
    website: "",
    linkedin: "",
    facebook: "",
    twitter: "",
    instagram: "",
    youtube: "",
  },
  audienceDemographics: "",
  nicheCategory: "",

  // Legacy fields
  impactReport: "",
  previousCampaigns: "",
  targetAudience: "",

  // Step 5: Terms
  termsAgreed: false,
};

const representativeVerificationSlice = createSlice({
  name: "representativeVerification",
  initialState,
  reducers: {
    updateRepresentativeVerification: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetRepresentativeVerification: () => initialState,
  },
});

export const {
  updateRepresentativeVerification,
  resetRepresentativeVerification,
} = representativeVerificationSlice.actions;

export default representativeVerificationSlice.reducer;
